import {
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    signOut,
    sendPasswordResetEmail,
    GoogleAuthProvider,
    signInWithPopup,
    updateProfile,
    deleteUser,
} from "firebase/auth";

import {
    doc,
    getDoc,
    setDoc,
    serverTimestamp,
} from "firebase/firestore";

import { auth, db } from "../firebase";

import {
    updatePassword,
} from "firebase/auth";

const googleProvider = new GoogleAuthProvider();

export async function createAccount({
    displayName,
    email,
    password,
    emailUpdates,
}) {

    const credential =
        await createUserWithEmailAndPassword(
            auth,
            email,
            password
        );

    // Make sure Firebase Auth has issued a token
    await credential.user.getIdToken(true);

    try {

        if (displayName) {
            await updateProfile(
                credential.user,
                { displayName }
            );
        }

        await setDoc(
            doc(db, "users", credential.user.uid),
            {
                displayName: displayName || "",
                email,
                emailUpdates,
                premium: false,
                createdAt: serverTimestamp(),
            }
        );

        return credential.user;

    } catch (error) {

        console.error(error);

        // Remove the Auth account if creating the Firestore profile fails
        await deleteUser(credential.user);

        throw error;

    }
}

export async function login(email, password) {

    const credential =
        await signInWithEmailAndPassword(
            auth,
            email,
            password
        );

    return credential.user;

}

export async function logout() {

    await signOut(auth);

}

export async function loginWithGoogle() {

    const credential =
        await signInWithPopup(
            auth,
            googleProvider
        );

    const ref = doc(
        db,
        "users",
        credential.user.uid
    );

    const snapshot = await getDoc(ref);

    const isNewUser = !snapshot.exists();

    if (isNewUser) {

        await setDoc(ref, {

            displayName:
                credential.user.displayName || "",

            email:
                credential.user.email,

            emailUpdates: false,

            premium: false,

            createdAt:
                serverTimestamp(),

        });

    }

    return {
        user: credential.user,
        isNewUser,
    };

}

export async function resetPassword(email) {

    await sendPasswordResetEmail(
        auth,
        email
    );

}
export async function changePassword(
    newPassword
) {

    if (!auth.currentUser) {
        throw new Error(
            "Not signed in."
        );
    }

    await updatePassword(
        auth.currentUser,
        newPassword
    );

}